import { Dropover, Label, Text } from "@xometry/xometry_loft";
import { Italic, TooltipWrapper } from "./Shared.style";

type LabelWithOptionalFlagProps = {
  required?: boolean;
  children: React.ReactNode;
  suffix?: string;
  htmlFor?: string | undefined;
  tooltip?: string | undefined;
};

const LabelWithOptionalFlag = ({
  required,
  children,
  suffix,
  htmlFor,
  tooltip,
}: LabelWithOptionalFlagProps) => (
  <Label htmlFor={htmlFor}>
    {`${children}${suffix}`}
    {required && <span css={Italic}> Required</span>}
    {tooltip && (
      <TooltipWrapper>
        <Dropover>
          <Dropover.Trigger>
            <i className="fas fa-info-circle" />
          </Dropover.Trigger>
          <Dropover.Content maxWidth="300px">
            <Text kind="body-sm">{tooltip}</Text>
          </Dropover.Content>
        </Dropover>
      </TooltipWrapper>
    )}
  </Label>
);

LabelWithOptionalFlag.defaultProps = {
  required: false,
  suffix: "",
  htmlFor: undefined,
  tooltip: "",
};

export { LabelWithOptionalFlag };
